import React from "react";
import { withTranslation } from 'react-i18next';

import Button from '../../components/CustomButtons/Button';
import CloseButton from "../../assets/img/buttons/delete.svg";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

import './style.scss';

class FileImportDialog extends React.Component {
  render() {
    const { isOpen, onClose, t } = this.props;
    return (
      <Dialog maxWidth={false} open={isOpen}>
        <MuiDialogTitle className="file-import-title" disableTypography>
          <Typography variant="h6" className="dialog-title">{ t('file_import') }</Typography>
          {onClose ? (
            <IconButton aria-label="close" className="close-btn" onClick={onClose}>
              <img alt="file-import-close-btn" src={CloseButton}/>
            </IconButton>
          ) : null}
        </MuiDialogTitle>
        <div className="file-import-content">
          { t('import_file_confirm') }
        </div>
        <div className="file-import-btn-container">
          <Button
            className="cancel-btn"
            onClick={() => onClose()}
          >
            { t('cancel').toUpperCase() }
          </Button>
          <Button
            className="create-btn"
            onClick={this.props.onStartButton}
          >
            { t('import_file').toUpperCase() }
          </Button>
        </div>
      </Dialog>
    );
  }
}

export default withTranslation()(FileImportDialog);
